import {
    IconLayoutDashboard,
    IconSettings,
    IconReceipt2,
    IconBuildingWarehouse,
} from '@tabler/icons-vue';

export interface menu {
    header?: string;
    title?: string;
    icon?: any;
    to?: string;
    chip?: string;
    chipColor?: string;
    chipVariant?: string;
    chipIcon?: string;
    children?: menu[];
    disabled?: boolean;
    type?: string;
    subCaption?: string;
    superAdminOnly?: boolean;
}

const sidebarItem: menu[] = [
    { header: 'T&T Administrador' },
    {
        title: 'Dashboard',
        icon: IconLayoutDashboard,
        to: '/tat/admin/Dashboard',
    },
    {
        title: 'Configuración',
        icon: IconSettings,
        to: '/tat/admin/Asignaciones',
    },
    {
        title: 'Pedidos',
        icon: IconReceipt2,
        to: '/tat/admin/Pedidos',
    },
    {
        title: 'Centros Operativos',
        icon: IconBuildingWarehouse,
        to: '/tat/admin/CentrosOperativos',
        superAdminOnly: true,
    },
];

export default sidebarItem;
